import { Box, Flex } from '@chakra-ui/react';

import Loading from './Loading';

/**
 * A full screen loader component that occupies 100% of the viewport height.
 */
export function FullScreenLoader({ loadingText }: { loadingText?: string }) {
  return (
    <Box
      minHeight="100vh"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      width="100%"
    >
      <Loading loadingText={loadingText} />
    </Box>
  );
}

/**
 * A loader component that expands to fill a flex parent container.
 */
export function FlexLoader({ loadingText }: { loadingText?: string }) {
  return (
    <Flex
      display="flex"
      flexDirection="column"
      justifyContent="center"
      width="100%"
      flexGrow={1}
    >
      <Loading loadingText={loadingText} />
    </Flex>
  );
}
